import { reportUnitsWithPermissionTypes } from "./types";

const {
  SET_UNITS_WITH_PERMISSION_FILTERS,
  RESTORE_INITIAL
} = reportUnitsWithPermissionTypes;

const initialState = {
  station: null,
};

export const reportUnitsWithPermissionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_UNITS_WITH_PERMISSION_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
